<template>
    <div class="card-body p-0 position-relative">
    	
        <div v-if="hasElements" class="">
    		<table class="table table-hover">
    			<tableHead :options="options" @options:changed="optionschanged"></tableHead>
                <elementDisplay v-for="(element, index) in elements" :key="element.id" :element="element" :filters="filters" @filters:changed="filterschanged" :position="orderFirst + index" :loading="loading" @loading:changed="loadingchanged" @element:updated="elementsUpdated" />
    		</table>
    	</div>
        <div v-else class="card-body d-flex align-items-center justify-content-center bg-light p-2" style="height:120px;">
            <div class="align-self-center text-center">
                <h6> No users </h6>
                <div class="text-muted">Try adjusting your filters or search term.</div>
            </div>
        </div>
        <div v-if="isLoading" class="position-absolute top-0 bottom-0 right-0 left-0 w-100 h-100 d-flex align-items-center justify-content-center " style="background-color: rgba(255, 255, 255, 0.6);">
            <div class="loader loader-inline no-margin-top align-self-center"></div>
        </div>
    </div>
</template>

<script>
import draggable from "vuedraggable";
import elementDisplay from './element.vue'
import tableHead from './tablehead.vue'

export default {
	components : {
		elementDisplay,
		tableHead,
        draggable
	},
    props: {
        elements: {
            type: Array,
            default: []
        },
        options : {
        	type: Object,
            required : true
        },
        filters : {
            type: Object,
            required : true
        },
        meta : {
            type: Object,
            required : true
        },
        loading : {
            type: Object,
            default : {
                status : false
            }
        }
    },
    computed: {
	    orderFirst: function() {
	      return this.meta.current_page * this.options.per_page - this.options.per_page + 1
        },
    	hasElements : function(){
            return this.elements.length > 0;
        },
        isLoading : function(){
            return this.loading.status;
        },
        draggingActive : function(){
            return this.filters.category && this.filters.collection && !this.filters.search && !this.filters.status;
        }
    },
    watch : {
        elements(){}
    },
    data() {
        return {
            dragging: false
        }
    },
    mounted(){
    },
    methods : {
    	optionschanged : function(options){
    		this.$emit('options:changed', options)
    	},
        filterschanged : function(options){
            this.$emit('filters:changed', options)
        },
        loadingchanged : function(options){
            this.$emit('loading:changed', options)
        },
        elementsUpdated : function(options){
            this.$emit('element:updated', options)
        },

    }
};
</script>